import user from "./user"
import screen from "./user/screen.js"
import management from "./management"

export default {
	user,
	screen,
	management
}
